import EFPicture from 'elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function C() {
    const { useLang, useRouter, gtm } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('powerindependence');
    const PRODUCT_MAP: any = {
        de: [
            {
                img: '/responsive/picture/power-independence/2_2',
                title: t('secC_list2_title'),
                desc: t('secC_list2_desc'),
                url: '#power-independence-F',
                text: t('secC_text'),
            },
            {
                img: '/responsive/picture/power-independence/2_1',
                title: t('secC_list1_title'),
                desc: t('secC_list1_desc'),
                url: '#power-independence-D',
                text: t('secC_text'),
            },
            {
                img: '/responsive/picture/power-independence/2_3',
                title: t('secC_list3_title'),
                desc: t('secC_list3_desc'),
                url: '#power-independence-J',
            },
        ],
        eu: [
            {
                img: '/responsive/picture/power-independence/2_2',
                title: t('secC_list2_title'),
                desc: t('secC_list2_desc'),
                url: '#power-independence-F',
                text: t('secC_text'),
            },
            {
                img: '/responsive/picture/power-independence/2_1',
                title: t('secC_list1_title'),
                desc: t('secC_list1_desc'),
                url: '#power-independence-D',
                text: t('secC_text'),
            },
            {
                img: '/responsive/picture/power-independence/2_3',
                title: t('secC_list3_title'),
                desc: t('secC_list3_desc'),
                url: '#power-independence-J',
            },
        ],
        fr: [
            {
                img: '/responsive/picture/power-independence/2_1',
                title: t('secC_list1_title'),
                desc: t('secC_list1_desc'),
                url: '#power-independence-D',
                text: t('secC_text'),
            },
            {
                img: '/responsive/picture/power-independence/2_2',
                title: t('secC_list2_title'),
                desc: t('secC_list2_desc'),
                url: '#power-independence-F',
                text: t('secC_text'),
            },
            {
                img: '/responsive/picture/power-independence/2_3',
                title: t('secC_list3_title'),
                desc: t('secC_list3_desc'),
                url: '#power-independence-J',
            },
        ],
        uk: [
            {
                img: '/responsive/picture/power-independence/2_1',
                title: t('secC_list1_title'),
                desc: t('secC_list1_desc'),
                url: '#power-independence-D',
                text: t('secC_text'),
            },
            {
                img: '/responsive/picture/power-independence/2_3',
                title: t('secC_list3_title'),
                desc: t('secC_list3_desc'),
                url: '#power-independence-J',
            },
        ],
        it: [
            {
                img: '/responsive/picture/power-independence/2_2',
                title: t('secC_list2_title'),
                desc: t('secC_list2_desc'),
                url: '#power-independence-F',
                text: t('secC_text'),
            },
            {
                img: '/responsive/picture/power-independence/2_3',
                title: t('secC_list3_title'),
                desc: t('secC_list3_desc'),
                url: '#power-independence-J',
            },
        ],
        es: [
            {
                img: '/responsive/picture/power-independence/2_2',
                title: t('secC_list2_title'),
                desc: t('secC_list2_desc'),
                url: '#power-independence-F',
                text: t('secC_text'),
            },
            {
                img: '/responsive/picture/power-independence/2_3',
                title: t('secC_list3_title'),
                desc: t('secC_list3_desc'),
                url: '#power-independence-J',
            },
        ],
    };
    const cards: any = PRODUCT_MAP[locale];

    return (
        <div id="power-independence-C" className={`power-independence-C ${css['power-independence-C']}`}>
            <div className="ef-box">
                <div className="text-box">
                    <p className="title">{t('secC_title')}</p>
                </div>
                <ul className="card-box">
                    {cards?.map((card: any, k: number) => (
                        <a
                            className="card"
                            href={card?.url}
                            key={k}
                            onClick={() =>
                                gtm.push({
                                    event: 'uaEvent',
                                    event_name: 'activity_button',
                                    page_name: 'power-independence',
                                    list_name: t('secC_title'),
                                    button_name: card?.title,
                                    function: 'Anchor',
                                })
                            }
                        >
                            <div className="card-img">
                                <EFPicture src={`${card?.img}.jpg`} srcPad={`${card?.img}_375.jpg`} srcMobile={`${card?.img}_375.jpg`} alt={card?.title} />
                            </div>
                            <div className="card-text">
                                <p className="card-title">{card?.title}</p>
                                <div className="link-box">
                                    <p className="card-desc pc">{card?.desc}</p>
                                    <div className="card-link">
                                        <p className="card-desc h5">{card?.desc}</p>
                                        <svg className="down-icon" width="30" height="30" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M15.5023 26.5C12.3269 26.5 9.45189 25.2126 7.3707 23.1314C5.28951 21.0502 4.00213 18.1752 4.00213 14.9998C4.00213 11.8245 5.28951 8.94945 7.3707 6.86826C9.45189 4.78707 12.3269 3.49969 15.5023 3.49969C18.6777 3.49969 21.5527 4.78707 23.6339 6.86826C25.7151 8.94945 27.0024 11.8245 27.0024 14.9998C27.0024 18.1752 25.7151 21.0502 23.6339 23.1314C21.5527 25.2126 18.6777 26.5 15.5023 26.5Z"
                                                stroke="white"
                                                strokeWidth="1.80002"
                                            />
                                            <path
                                                d="M20.5068 14.9999L15.5068 20L10.5067 14.9999M15.5068 18.125L15.5068 9.99987"
                                                stroke="white"
                                                strokeWidth="1.80002"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </a>
                    ))}
                </ul>
            </div>
        </div>
    );
}
